import { useEffect } from 'react';

/**
 * Vienots modal logs visā aplikācijā.
 * Aizveras TIKAI:
 *   - spiežot X augšējā stūrī,
 *   - ar ESC taustiņu,
 *   - ar Atcelt (ja forma to piedāvā).
 * Klikšķis ārpus loga NEAIZVER (lai nepazustu rakstītie dati).
 */
const Modal = ({ title, onClose, children, maxWidth = 520 }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    // Bloķējam fona scroll
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  return (
    <div className="modal-overlay" /* nekāda onClick uz overlay */>
      <div className="modal" style={{ maxWidth }} role="dialog" aria-modal="true">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
          <div className="modal-title" style={{ margin: 0 }}>{title}</div>
          <button
            type="button"
            aria-label="Aizvērt"
            onClick={onClose}
            style={{
              background: 'transparent', border: 'none', cursor: 'pointer',
              fontSize: 22, lineHeight: 1, color: '#6b7280', padding: '0 4px',
            }}
          >×</button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
